export default __webpack_public_path__ + "static/noogie-50166b92f909e46fb9c3378df94dbf24.svg";